var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},_vm._l((_vm.menu),function(item){return _c('v-list-tile',{key:item.name},[_c('v-list-tile-content',[_c('v-btn',{staticClass:"blue--text text--darken-3 accented-text",attrs:{"href":item.href,"flat":""}},[_vm._v(_vm._s(item.name))])],1)],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29b84618","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileMenu.vue
// module id = 72
// module chunks = 1